<xux-form-panel
  [title]="titleObs | async | translate"
  [description]="descriptionObs | async | translate"
  [panelId]="field.widgetData?.groupId"
  [disabled]="field.disabledObs | async"
>
  <xvi-schema-form-group
    panel-body-content
    [group]="field.widgetData?.group"
    [defaultWidgetFamily]="'xux'"
  ></xvi-schema-form-group>
</xux-form-panel>
